import { createContext } from 'react';

import { calcWindowSize } from 'hooks/useWindowSize';

import { WindowSizeContextProps } from './WindowSizeContext.types';

export const WindowSizeContext = createContext<WindowSizeContextProps>(calcWindowSize());
